<template>
  <div>
    <div class="columns is-gapless has-bg-white is-min-height-50 is-border-top">
      <div v-if='("lre" in lre && lre.lre && lre.lre.created_on) || ("sending_date" in lre && lre.sending_date)'
           class="column is-narrow has-bg-success is-flex is-padding-small">
        <span class="icon has-text-white is-self-centered"><i class="fas fa-check-circle"></i></span>
      </div>
      <div v-else class="column is-narrow has-bg-danger is-flex is-padding-small">
        <span class="icon has-text-white is-self-centered"><i class="fas fa-clock"></i></span>
      </div>
      <div class="column is-padding-left is-self-centered">
        <span v-if='"lre" in lre && lre.lre && lre.lre.created_on'
              class="is-size-6 is-uppercase has-text-weight-medium">Recommandé (LRE) envoyé le {{lre.lre.created_on|date}}</span>
        <span v-else-if='"sending_date" in lre && lre.sending_date'
              class="is-size-6 is-uppercase has-text-weight-medium">Recommandé (LRE) envoyé le {{lre.sending_date|date}}</span>
        <span v-else class="is-size-6 is-uppercase has-text-weight-medium">Recommandé en attente</span>
        <span v-if="buyer && buyer.email" class="is-size-7">({{buyer.email}})</span>
      </div>
      <div class="is-border-left column is-padding-small is-narrow is-self-centered">
        <span class="is-size-7 is-uppercase">GESTION RECOMMANDÉ</span>
      </div>
      <div v-if="!open" class="column is-narrow has-text-right is-border-left">
        <button @click="open = true"
                class="button is-grey is-inverted is-borderless is-min-width-0 is-min-height-full is-radiusless w50p has-text-primary">
          <span class="icon"><i class="fal fa-chevron-down"></i></span></button>
      </div>
      <div v-else class="column is-narrow has-text-right is-border-left">
        <button @click="open = false"
                class="button is-grey is-inverted is-borderless is-min-width-0 is-min-height-full is-radiusless w50p has-text-primary">
          <span class="icon"><i class="fal fa-chevron-up"></i></span></button>
      </div>
      <div v-if="index >= 1" class="column is-narrow has-text-right is-border-left">
        <button @click="deleteLre"
                class="button is-grey is-inverted is-borderless is-min-width-0 is-min-height-full is-radiusless w50p has-text-primary">
          <span v-if="!loadingDelete" class="icon">
            <i class="fal fa-trash-alt"></i>
          </span>
          <span v-else>
            <i class="fas fa-spinner fa-spin is-margin-xsmall"></i>
          </span>
        </button>
      </div>
    </div>
    <div v-show="open" class="is-multiline columns is-gapless has-bg-white is-min-height-50 is-border-top">
      <div v-show="!envoiDemat" class="column is-12 columns is-gapless is-padding-top is-padding-bottom">
        <div class="column is-narrow w50p"></div>
        <div class="column is-narrow is-size-5 is-size-6-widescreen is-size-4-fullhd">
          <i class="fal fa-5x fa-mail-bulk"></i>
        </div>
        <div class="column is-9 is-narrow is-margin-left-large is-padding-top-xxsmall">
          <div class="title is-3 is-marginless  has-text-weight-medium">Courrier recommandé</div>
          <div class="column columns is-paddingless is-gapless is-centered is-padding-top is-padding-bottom">
            <div class="column">
              <label for="" class="label">Numéro A/R</label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fas fa-barcode-read"></i></span>
                  </a>
                </div>
                <div class="control is-expanded" :class="{'field has-addons' : save.numero_ar}">
                  <v-input :id="index + '-numero_ar'"
                           :name="index + '-numero_ar'"
                           :model="courrier.numero_ar"
                           :errors-bag="errors"
                           data-vv-value-path="val"
                           @input="val => updateStep('numero_ar', val)"></v-input>
                  <div v-if="save.numero_ar" class="control">
                    <a @click="saveCourrier('numero_ar')" class="button is-success is-square tooltip is-tooltip-right"
                       data-tooltip="Sauvegarder numéro ar">
                      <span v-if="!loading.numero_ar" class="icon"><i class="fas fa-save"></i></span>
                      <span v-else class="icon"><i class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
                    </a>
                  </div>
                  <div v-if="save.numero_ar" class="control">
                    <a @click="remote('numero_ar')" data-tooltip="Annuler la modification du numéro ar"
                       class="button tooltip is-tooltip-right is-square is-draft">
                      <span class="icon has-text-white"><i class="fas fa-times"></i></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-padding-left-xxsmall">
              <label for="" class="label">Envoi postal A/R</label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded" :class="{'field has-addons' : save.sending_date}">
                  <flat-pickr type="date" class="control is-expanded"
                              ref="sending_date"
                              @input="updateStep('sending_date', $event)"
                              v-model="courrier.sending_date"
                              :disabled="!(isAdmin || isSectorManager)"
                              :config="dateConfig">
                  </flat-pickr>
                  <div v-if="save.sending_date" class="control">
                    <a @click="saveCourrier('sending_date')"
                       class="button is-success is-square tooltip is-tooltip-right"
                       data-tooltip="Valider l'envoi postal">
                      <span v-if="!loading.sending_date" class="icon"><i class="fas fa-save"></i></span>
                      <span v-else class="icon"><i class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
                    </a>
                  </div>
                  <div v-if="save.sending_date" class="control">
                    <a @click="remote('sending_date')" data-tooltip="Annuler la modification de l'envoi postal"
                       class="button tooltip is-tooltip-right is-square is-draft">
                      <span class="icon has-text-white"><i class="fas fa-times"></i></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-padding-left-xxsmall">
              <label for="" class="label">Réception A/R</label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fal fa-mailbox"></i></span>
                  </a>
                </div>
                <div class="control is-expanded" :class="{'field has-addons' : save.ar_received_date}">
                  <flat-pickr type="date" class="control is-expanded"
                              ref="ar_received_date"
                              @input="updateStep('ar_received_date', $event)"
                              v-model="courrier.ar_received_date"
                              :disabled="!(isAdmin || isSectorManager)"
                              :config="dateConfig">
                  </flat-pickr>
                  <div v-if="save.ar_received_date" class="control">
                    <a @click="saveCourrier('ar_received_date')"
                       class="button is-success is-square tooltip is-tooltip-right"
                       data-tooltip="Valider la récéption ar">
                      <span v-if="!loading.ar_received_date" class="icon"><i class="fas fa-save"></i></span>
                      <span v-else class="icon"><i class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
                    </a>
                  </div>
                  <div v-if="save.ar_received_date" class="control">
                    <a @click="remote('ar_received_date')" data-tooltip="Annuler la modification de la récéption ar"
                       class="button tooltip is-tooltip-right is-square is-draft">
                      <span class="icon has-text-white"><i class="fas fa-times"></i></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!lreSent && envoiDemat"
           class="notification column is-min-height-50 is-flex is-warning has-text-centered is-marginless">
        <p class="is-self-centered has-text-centered w100 is-uppercase is-size-7">
          <span class="icon has-text-danger"><i class="fas fa-exclamation-triangle"></i></span>
          <span class="has-text-weight-bold">une procédure LRE (lettre recommandée maiL) ne peut pas être annulée.</span>
        </p>
      </div>
      <div v-show="envoiDemat" class="column is-12 columns is-gapless is-padding-top is-padding-bottom">
        <div class="column is-narrow w50p"></div>
        <div class="column is-narrow is-size-5 is-size-6-widescreen is-size-4-fullhd">
          <i class="fal fa-5x fa-mail-bulk"></i>
        </div>
        <div v-if="!lreSent" class="column is-9 is-narrow is-margin-left-large is-padding-top-xxsmall">
          <div class="is-padding-bottom title is-3 is-marginless  has-text-weight-medium">Vous vous apprétez à envoyer
            un courrier recommandé éléctronique (LRE)
          </div>
          <div>La Lettre Recommandée Electronique, ou LRE, est le remplaçant numérique du courrier recommandé postal
            reconnu par la loi française.
            <br>
            <b>Si le destinataire n’est pas un professionnel, il est nécessaire de recueillir son accord pour lui faire
              parvenir une LRE.
              Dans tous les cas il est necessaire de disposer d'un mail valide et enregistré dans la fiche de
              l’acquéreur ou co-acquéreur.</b>
          </div>
          <div class="column is-narrow columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
            <div class="column">
              <button @click="envoiDemat = false" class="button is-uppercase is-transform-none is-grey is-full">
                <span>Annuler</span>
              </button>
            </div>
            <div class="column is-margin-left-small">
              <button @click="setLre()" class="button is-uppercase is-transform-none is-success is-full">
                <span v-if='!loadingLre'>ENVOYER LRE À L’ACQUÉREUR</span>
                <span v-else><i class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
              </button>
            </div>
          </div>
        </div>
        <div v-else-if="lreSent && 'lre' in lre"
             class="column is-9 is-narrow is-margin-left-large is-padding-top-xxsmall">
          <div class="title is-3 is-marginless  has-text-weight-medium">Courrier recommandé éléctronique (LRE)</div>
          <div><span class="is-size-7 has-text-success is-uppercase has-text-weight-medium">procédure LANCÉE LE {{lre.lre.created_on | date}}</span>
          </div>
          <div class="columns is-padding-top-small">
            <div class="column is-padding-top-xsmall is-padding-left-xsmall">
              <ul class="steps is-xsmall steps--vertical-vad steps--separatorColorClassic-Vad">
                <li class="step-item"
                    :class="sending ? 'is-success is-completed is-active' : ''"
                    data-step-id="0">
                  <div class="step-marker">
                    <span class="icon"><i class="fa fa-check"></i></span>
                  </div>
                  <div class="step-details">
                    <span class="has-text-weight-medium is-uppercase"
                          :class="sending ? '' : 'has-text-grey-light'">
                      En cours d’envoi
                    </span>
                  </div>
                </li>
                <li class="step-item"
                    :class="sent ? 'is-success is-completed is-active' : ''"
                    data-step-id="0">
                  <div class="step-marker">
                    <span class="icon"><i class="fa fa-check"></i></span>
                  </div>
                  <div class="step-details">
                    <span class="has-text-weight-medium is-uppercase"
                          :class="sent ? '' : 'has-text-grey-light'">
                      Envoyé <a @click="openPreview()"
                                v-if="(lre.lre.status === 'ev' || lre.lre.status === 'dp') && lre.lre.proof"
                                class="is-underline">(preuve d'envoi)</a>
                    </span>
                  </div>
                </li>
                <li class="step-item"
                    :class="[lre.lre.status === 'refused' || lre.lre.status === 'bounced' ? 'is-danger is-completed is-active' : '', lre.lre.status === 'ar' ? 'is-success is-completed is-active' : '']"
                    data-step-id="0">
                  <div class="step-marker">
                    <span v-if="lre.lre.status === 'refused' || lre.lre.status === 'bounced'"
                          class="icon"><i class="fa fa-exclamation"></i></span>
                    <span v-else
                          class="icon"><i class="fa fa-check"></i></span>
                  </div>
                  <div class="step-details">
                    <div class="has-text-weight-medium is-uppercase">
                      <span v-if="lre.lre.status === 'refused'">
                        Refusée par le destinataire <a @click="openPreview()" v-if="lre.lre.proof" class="is-underline">(preuve de refus)</a>
                      </span>
                      <span v-else-if="lre.lre.status === 'bounced'">
                        Erreur lors de la Réception du lre
                      </span>
                      <span v-else :class="lre.lre.status === 'ar' ? '' : 'has-text-grey-light'">
                        Réceptionné <a @click="openPreview()" v-if="lre.lre.status === 'ar' && lre.lre.proof"
                                       class="is-underline">(preuve de réception)</a>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div v-if="lre.lre.status === 'refused' || lre.lre.status === 'bounced'" class="column">
              <button @click="setLre" class="button is-small is-transform-none is-danger is-full">
                <span v-if='!loadingLre' class="is-uppercase">relancer PROCÉDURE</span>
                <span v-else><i class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!envoiDemat && lreEnabled && !this.lre.numero_ar && !this.lre.sending_date && !this.lre.ar_received_date"
           class="column" @click="envoiDemat = true">
        <button class="button is-success is-fullwidth is-radiusless is-min-height-50">
          <span>ENVOYER UN RECOMMANDÉ PAR COURRIER ÉLECTRONIQUE
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'SruItem',
    props: {
      toOpen: String,
      step: Object,
      sendingDate: String,
      index: Number,
      buyerPk: String,
      advPk: String,
      lre: Object,
      buyers: Array
    },
    data () {
      return {
        loadingDelete: false,
        loadingLre: false,
        loading: {
          numero_ar: false,
          sending_date: false,
          ar_received_date: false
        },
        save: {
          numero_ar: false,
          sending_date: false,
          ar_received_date: false
        },
        courrier: {
          ar_received_date: null,
          numero_ar: null,
          sending_date: null
        },
        initCourrier: {},
        saveNum: false,
        saveSend: false,
        saveReceived: false,
        openProof: false,
        lreSent: false,
        envoiDemat: false,
        dateConfig: {
          altInput: true,
          altFormat: 'd/m/Y',
          dateFormat: 'Z'
        },
        open: false
      }
    },
    filters: {
      date: function (value) {
        let date = moment(value).format('DD/MM/YYYY')
        let hour = moment(value).format('HH')
        let minute = moment(value).format('mm')

        return date + ' à ' + hour + 'h' + minute
      }
    },
    computed: {
      ...mapState(['configs']),
      ...mapGetters(['isAdmin', 'isSectorManager']),
      lreEnabled () {
        if ('LRE_ENABLED' in this.configs && this.configs.LRE_ENABLED) {
          return this.configs.LRE_ENABLED.toString() === '1'
        }
        return false
      },
      buyer () {
        let result = this.buyers.filter(x => {
          return x.pk === this.buyerPk
        })
        return result[0]
      },
      sending () {
        if ('lre' in this.lre && this.lre.lre) {
          return this.lre.lre.status === 'waiting' || this.lre.lre.status === 'dp' ||
            this.lre.lre.status === 'ev' || this.lre.lre.status === 'ar' ||
            this.lre.lre.status === 'refused' || this.lre.lre.status === 'bounced'
        } else return false
      },
      sent () {
        if ('lre' in this.lre && this.lre.lre) {
          return this.lre.lre.status === 'dp' || this.lre.lre.status === 'ev' ||
            this.lre.lre.status === 'ar' || this.lre.lre.status === 'refused' || this.lre.lre.status === 'bounced'
        } else return false
      }
    },
    methods: {
      remote (key) {
        this.save[key] = false
        this.courrier[key] = this.initCourrier[key]
      },
      updateStep (key, value) {
        if (value !== this.initCourrier[key]) {
          this.courrier[key] = value
          this.save[key] = true
        }
      },
      async deleteLre () {
        this.loadingDelete = true
        try {
          await this.$api.advService.deleteAdfLre(this.advPk, this.lre.pk)
        } catch (e) {
          console.log(e)
        }
      },
      async saveCourrier (key) {
        let params = {
          step_uuid: this.step.construction_step.uuid,
          buyer: this.buyerPk
        }
        params[key] = this.courrier[key]
        this.initCourrier[key] = this.courrier[key]
        this.loading[key] = true
        if (key === 'ar_received_date' || key === 'sending_date') {
          params[key] = moment(params[key]).hour(new Date().getHours()).minute(new Date().getMinutes()).toISOString()
        }
        try {
          let res = await this.$api.advService.postAdfLre(this.advPk, params)
          console.log(res)
        } catch (e) {
          console.log(e)
        } finally {
          this.$notify({
            type: 'is-success',
            text: 'Le champ à été mis à jour.'
          })
          // this.save[key] = false
        }
      },
      openPreview () {
        let params = {
          idAdv: this.advPk,
          linkEmbed: this.lre.lre.proof
        }
        this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW', params })
      },
      setLre () {
        this.loadingLre = true
        this.$emit('setLre', this.step.construction_step.uuid, this.buyerPk, 1)
      }
    },
    created () {
      // if ('lre' in this.lre && this.lre.lre) {
      //   this.envoiDemat = true
      //   this.lreSent = true
      //   this.open = true
      // }
      console.log(this.toOpen)
      if (this.toOpen === this.lre.pk) {
        this.open = true
        if ('lre' in this.lre && this.lre.lre) {
          this.envoiDemat = true
          this.lreSent = true
        }
      }
      this.initCourrier.ar_received_date = this.lre.ar_received_date
      this.initCourrier.numero_ar = this.lre.numero_ar
      this.initCourrier.sending_date = this.lre.sending_date
      this.courrier.ar_received_date = this.lre.ar_received_date
      this.courrier.numero_ar = this.lre.numero_ar
      this.courrier.sending_date = this.lre.sending_date
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/SruItem.vue